import {Breakpoint} from "modules/enums";

export function minifyHTML(template: string) {
	return template.replace(/\n|\t/g, " ").replace(/> *</g, "><").trim();
}

export function arrayMove(arr: unknown[], fromIndex: number, toIndex: number) {
	const element = arr[fromIndex];
	arr.splice(fromIndex, 1);
	arr.splice(toIndex, 0, element);
}

export function getBreakpoint(width: number) {
	if (width > 1600) {
		return Breakpoint.ExtraLarge;
	} else if (width > 1200) {
		return Breakpoint.Large;
	} else if (width > 900) {
		return Breakpoint.Medium;
	} else if (width > 600) {
		return Breakpoint.Small;
	} else {
		return Breakpoint.ExtraSmall;
	}
}
